<nb-card
  class="mt-{{ cardMargin }}"
  [ngClass]="{ 'background-grey-light': changeBackground }"
>
  <nb-card-body
    [ngClass]="{ 'p-0': noPaddingCard }"
    class="d-flex flex-column align-items-center"
  >
    <img
      style="width: 82px; height: 80px"
      [src]="imgUrl"
      *ngIf="showImage && imgUrl"
    />
    <h5
      [ngClass]="{ 'error-text': status === 'error' }"
      *ngIf="primaryMsg"
      class="mt-{{ primaryMargin }}"
    >
      {{ primaryMsg }}
    </h5>
    <div
      class="mt-{{ secondaryMargin }}"
      [ngClass]="{ 'error-text': status === 'error' }"
      *ngIf="secondaryMsg"
      class="text-center paragraph-3"
      [ngStyle]="{ 'max-width.%': secondaryMsgWidth || 100 }"
    >
      {{ secondaryMsg }}
    </div>
    <div *ngIf="showBtn" class="mt-{{ spacing }}">
      <app-rbac-button
        [label]="buttonText"
        [icon]="emptyIcon"
        [toolTip]="emptyTooltip"
        [action]="action"
        (onClick)="navigate()"
        size="small"
        status="primary"
        [toolTip]="toolTip"
        [setClass]="setClass"
        [isFciPack]="isFciPack"
        [dataAttrActionId]="buttonDataAttrActionId"
      ></app-rbac-button>
    </div>
    <a
      class="mt-3"
      *ngIf="showLink"
      href="{{ linkUrl }}"
      target="{{ targetValue }}"
      >{{ linkText }}</a
    >
  </nb-card-body>
</nb-card>
